import React, {useCallback} from 'react';
import {useLocalization} from 'localization';
import {getManifestationDownloadFileInfo} from 'api';
import {useGetTokens} from 'services/auth';
import {ToolButton} from 'components';

type Props = {
  ean: string;
  miniMode?: boolean;
};

export const ManifestationDownload: React.FC<Props> = ({ean, miniMode}) => {
  const getTokens = useGetTokens();
  const {t} = useLocalization();

  const onClick = useCallback(() => {
    getManifestationDownloadFileInfo(ean, getTokens).then(result => {
      if (result.url) {
        window.open(result.url, '_blank');
      }
    });
  }, [ean, getTokens]);

  return (
    <ToolButton
      title={t('page.metadata.manifestation.tools.download')}
      icon="Download"
      onClick={onClick}
      iconOnly={miniMode}
    />
  );
};
